import script from "./Configuration.vue?vue&type=script&setup=true&lang=js"
export * from "./Configuration.vue?vue&type=script&setup=true&lang=js"

import "./Configuration.vue?vue&type=style&index=0&id=6771d804&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6771d804"]])

export default __exports__